import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import { apiClient } from '../../../services/api'
import {Button, Form} from 'react-bootstrap'
const OAuthSimLogin = (props) => {
    let history = useHistory()
    const [username, setUsername] = useState("times_teacher2");

    useEffect(() => {
    }, [])

    const callAuthoriz = async () => {
        
      const authorizeRes = await apiClient
        // .create({
        //   baseURL: 'https://api-dev.my-dev.co',
        //   headers: {    // can be common or any other method
        //     'app-key': 'OIsIlMiZT7SuIZJcnR0kJK3omXA3PEc6'
        //   }
        // })
        .get('/security/oauth/authorize', {
        params: {
          client_id : '23e72b73-df65-4f00-b15c-18d9fd577a45',
          client_secret : 'p5QnQ96RLVgPy7l-EFd4E4QBvMHJBqq9kduK9GRYVwY5Bb-duFeX_MEUEueE9O6S-DywVT-sS4y7yKmC2s9aNw',
          redirect_uri : 'https://my-admin-oauth-dev.my-dev.co/oauth/authorize-callback',
          state : 'state',
          response_type : 'code'
        },
        // withCredentials: true,    
        // crossorigin: true,    
        // mode: 'no-cors',
      })

      if(authorizeRes.data && authorizeRes.data.authorizationCode){
        history.push({
          pathname: '/oauth/authorize-callback',
          search: '?code='+authorizeRes.data.code + '&uid='+username,
        })
      }
    }

    const onValueChange = (e) => {
      let textValue = e.target.value
      textValue = textValue.replace(/[^A-Za-z0-9_]/gi, '')
      setUsername(textValue)
    }

    return (
        <>
        <div id="form-login" className="d-flex col-lg-8 col-xl-4 v4loginbox">
          <div className="d-flex col-sm-7 col-md-5 col-lg-12 px-0 v4loginform">
                <div className="w-100">
                    {/* Logo */}
                    <div className="" style={{marginBottom: 30}}>
                        <img src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`} alt="Brand"
                              className="login-logo"/>
                    </div>
                    {/* / Logo */}
                    <h3>Visual OAuth (KU-ALL-LOGIN)</h3>
                    {/* Form */}
                    <form className="">
                      <Form.Group>
                          <Form.Label> User Name </Form.Label>
                          <Form.Control 
                            type="email" 
                            value={username}
                            onChange={onValueChange}
                            placeholder="times_xxxxxx" />
                      </Form.Group>

                      <div className="d-flex justify-content-between align-items-center mb-3">

                          <Button variant="success" block style={{marginTop: 20}}
                                  onClick={() => callAuthoriz()}>
                              {'ยืนยันเข้าใช้งาน'}
                          </Button>
                      </div>
                    </form>
                    {/* / Form */}
                </div>
            </div>
        </div>
        </>
    )
}

export default OAuthSimLogin